module.exports = __webpack_public_path__ + "fonts/IstokWeb-Regular.c112bc58.ttf";